import React, { Component } from "react";
import { withRouter, Link } from "react-router-dom";
import { SignUpLink } from "./SignUp";
import GoHome from "./GoHome";
import "./styles/SignIn.css";

import { PasswordForgetLink } from "./PasswordForget";
import { auth } from "../firebase";
import * as routes from "../constants/routes";
import Button from "@material-ui/core/Button";
import Input from "@material-ui/core/Input";

const SignInPage = ({ history }) => (
  <div className="marginCont signinPage">
    <GoHome />
    <div id="signupH">&nbsp;</div>

    <div className="container blurred-box signInContainer">
      <h1>Login</h1>
      <SignInForm history={history} />
      <PasswordForgetLink />
      <SignUpLink />
      <div id="bluePart">&nbsp;</div>
    </div>
  </div>
);

const byPropKey = (propertyName, value) => () => ({
  [propertyName]: value
});

const INITIAL_STATE = {
  email: "",
  password: "",
  error: null
};

class SignInForm extends Component {
  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE };
  }

  onSubmit = event => {
    const { email, password } = this.state;
    const { history } = this.props;

    auth
      .doSignInWithEmailAndPassword(email, password)
      .then(() => {
        this.setState(() => ({ ...INITIAL_STATE }));
        history.push(routes.NUMBERS);
      })
      .catch(error => {
        this.setState(byPropKey("error", error));
      });

    event.preventDefault();
  };

  render() {
    const { email, password, error } = this.state;
    const isInvalid = password === "" || email === "";

    return (
      <form onSubmit={this.onSubmit}>
        {/* <input
          value={email}
          onChange={event =>
            this.setState(byPropKey("email", event.target.value))
          }
          type="text"
          placeholder="Email Address"
        /> */}
        <input
          placeholder="Email Address"
          value={email}
          onChange={event =>
            this.setState(byPropKey("email", event.target.value))
          }
          type="email"
          className="form-control"
        />
        <input
          value={password}
          onChange={event =>
            this.setState(byPropKey("password", event.target.value))
          }
          type="password"
          className="form-control"
          placeholder="Password"
        />
        {/* <input
          value={password}
          onChange={event =>
            this.setState(byPropKey("password", event.target.value))
          }
          type="password"
          placeholder="Password"
        /> */}
        {/* <button disabled={isInvalid} type="submit">
          Sign In
        </button> */}
        <Button
          variant="contained"
          type="submit"
          id="signInBtn"
          style={{ marginTop: "7px", backgroundColor: "#6376D7" }}
        >
          Sign In
        </Button>
        {error && <p>{error.message}</p>}
      </form>
    );
  }
}

const SignInLink = () => (
  <p>
    Do you already have an account? <Link to={routes.SIGN_IN}>Login Here</Link>
  </p>
);

export default withRouter(SignInPage);
export { SignInForm, SignInLink };
